import React from 'react'

import Dropzone from 'react-dropzone'
import DropzonePreview from '../forms/dropzone-preview'

import BaseModal from '../base-modal'
import {
  ModalForm,
  ModalFormRow,
  ModalFormBlock
} from '../modal-form/modal-form'

const constraints = {
  'width': '706px',
  'minWidth': '706px'
}

const statuses = {
  needs_work: 'Attention Req.',
  needs_review: 'Unresolved',
  permanent: 'Permanent'
}

export default ({
  fields: {
    beforeImage,
    afterImage,
    status,
    description
  },
  updating,
  handleSubmit,
  handleClose,
  modalTitle,
  submitButtonText
}) => (
  <BaseModal
    onClose={handleClose}
    title={modalTitle}
    constraints={constraints}
    contentClassName='work-orders-create-container'
  >
    <ModalForm onSubmit={handleSubmit} customClassName='work-orders-create-form'>
      <ModalFormRow>
        <ModalFormBlock>
          <label>before image</label>
          <Dropzone
            className='dropzone'
            activeClassName='active'
            multiple={false}
            onDrop={(files, e) => beforeImage.onChange(files[0])}
          >
            <DropzonePreview attribute={beforeImage} />
          </Dropzone>
        </ModalFormBlock>

      </ModalFormRow>
      {updating &&
        <ModalFormRow>
          <ModalFormBlock>
            <label>after image</label>
            <Dropzone
              className='dropzone'
              activeClassName='active'
              multiple={false}
              onDrop={(files, e) => afterImage.onChange(files[0])}
            >
              <DropzonePreview attribute={afterImage} />
            </Dropzone>
          </ModalFormBlock>
        </ModalFormRow>
      }
      <ModalFormRow>
        <ModalFormBlock>
          <label htmlFor='location'>status</label>
          <select {...status} value={status.value || ''}>
            <option disabled>Select</option>
            {Object.keys(statuses).map((statusKey) => (
              <option key={statusKey} value={statusKey}>{statuses[statusKey]}</option>
            ))}
          </select>
        </ModalFormBlock>
      </ModalFormRow>
      <ModalFormRow>
        <ModalFormBlock>
          <label htmlFor='notes'>notes</label>
          <textarea placeholder='Note text' {...description} />
        </ModalFormBlock>
      </ModalFormRow>
      <ModalFormRow>
        <ModalFormBlock submitButton>
          <button type='submit'>{submitButtonText || 'Submit'}</button>
        </ModalFormBlock>
      </ModalFormRow>
    </ModalForm>
  </BaseModal>
)



// WEBPACK FOOTER //
// ./src/components/pins/pin-form.js